module.exports = "<ul> <li ng-repeat=\"label in $ctrl.labels track by $index\">{{label}}</li> <li></li> <li ng-transclude=action></li> </ul> <article ng-transclude=accordion></article> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/product/product-check/product-check-item/product-check-item.template.html
// module id = 546
// module chunks = 0